export default __webpack_public_path__ + "static/media/orange-box.d8debaec.svg";